import { render, staticRenderFns } from "./ResolutionFilterItem.vue?vue&type=template&id=2594fd0e&"
import script from "./ResolutionFilterItem.vue?vue&type=script&lang=js&"
export * from "./ResolutionFilterItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports